export class FileLocationModel {
  locationId: number;
  fileName: string;
  documentType: string;

  constructor() {
    this.locationId = 0;
  }
}
